import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ExitSlipUnlockedSkillsState {
  // Skills ("SkillNode:<n>") whose unit-path card must not be locked because the student has sat that
  // skill's exit ticket. How they scored does not come into it — taking the ticket is what opens the
  // card, so the student can act on the result card's "Practice skill" call to action.
  //
  // Redux rather than a prop for the same reason as exitSlipPassedCountSlice: DashboardExitSlipQuery
  // owns the ticket query and useDashboardUnitPath builds the path, and the two are siblings under
  // DashboardCards with no common owner holding the query's data.
  skillIds: string[];
}

const initialState: ExitSlipUnlockedSkillsState = { skillIds: [] };

export const exitSlipUnlockedSkillsSlice = createSlice({
  name: 'exitSlipUnlockedSkills',
  initialState,
  reducers: {
    setExitSlipUnlockedSkillIds: (state: ExitSlipUnlockedSkillsState, action: PayloadAction<string[]>) => {
      // Same ids, same order: keep the existing array. The unit path memoizes on this value, so a
      // fresh array identity on every dispatch would rebuild the whole path for no reason.
      const unchanged =
        state.skillIds.length === action.payload.length &&
        state.skillIds.every((skillId, index) => skillId === action.payload[index]);
      if (unchanged) {
        return;
      }
      state.skillIds = action.payload;
    },
  },
});

export const selectedExitSlipUnlockedSkillIds = (state: RootState) => state.exitSlipUnlockedSkills.skillIds;

export const { setExitSlipUnlockedSkillIds } = exitSlipUnlockedSkillsSlice.actions;

export default exitSlipUnlockedSkillsSlice.reducer;
